<template>
    <div>

<!--        <div class="dropdown">-->

<!--            <button  class="btn bg-soft-warning dropdown-toggle p-2 show" type="button"-->
<!--                    id="noteDropdownButton" data-bs-toggle="dropdown" aria-expanded="true">-->
<!--                    <i  class="ti ti-notepad text-warning d-block"></i>-->
<!--            </button>-->

<!--            <div class="dropdown-menu p-0" aria-labelledby="noteDropdownButton" style="width: 300px;">-->
<!--Note Card here-->
<!--            </div>-->
<!--        </div>-->

        <!-- New card for displaying all questions with correct/incorrect marks -->

<!--        <div class="card rounded shadow mb-2 bg-soft-warning" v-if="currentQuestion">-->
<!--            <div class="p-3 ">-->
<!--                <h5 class="title mb-0">-->
<!--                    <i class="ti ti-notepad text-warning"></i>-->
<!--                    Note-->
<!--                </h5>-->
<!--            </div>-->
<!--            <div class="p-2">-->
<!--                <textarea-->
<!--                    ref="autoHeightTextarea"-->
<!--                    v-model="currentNote"-->
<!--                    @blur="saveNote"-->
<!--                    :style="{ height: `${height}px` }"-->
<!--                    @input="adjustHeight"-->
<!--                    class="form-control border-0"-->
<!--                    placeholder="Write your note here..." rows="4"></textarea>-->
<!--            </div>-->
<!--        </div>-->

        <div class="card rounded shadow mb-2 bg-soft-warning" v-if="currentQuestion">
            <div class="p-3 ">
                <h5 class="title mb-0">
                    <i class="ti ti-notepad text-warning"></i>
                    Note
                </h5>
            </div>
            <div class="p-2">
                <note-card v-if="currentQuestion" :current-question="currentQuestion"></note-card>
            </div>
        </div>
        <div class="card rounded shadow mb-2"
             v-if=" ( ( allQuestions.length > 0 && type ==='session' ) || ( this.isEnd() && type ==='mock_exams' )) "
        >
            <div class="p-3 border-bottom">
                <h5 class="title mb-0">
                    <i class="ti ti-stats-up text-muted"></i>
                    Exam results
                </h5>
            </div>

            <div class="p-3">

<!--                <b>Result</b>-->
                <div v-if="isEnd() && type === 'mock_exams'">
                    <div class="badge bg-success w-100 mb-2 text-start">{{ result.total_correct_questions }} correct answers</div>
                    <div class="badge bg-danger w-100 mb-2 text-start">{{ (result.total_questions ?? 0) - (result.total_correct_questions ?? 0) }} incorrect answers</div>
                    <div class="progress mb-2">
                        <div class="progress-bar pt-1" role="progressbar" :style="{ width: result.result + '%' }" :aria-valuenow="result.result" aria-valuemin="0" aria-valuemax="100">
                            {{ result.result }}%
                        </div>
                    </div>
                </div>

                <template v-for="question in allQuestions" :key="question.id">
                    <!--                    <div class="mb-3" v-if="question?.answer !== null">-->
                    <div class="mb-3">
                        <a href="javascript:void(0)"
                           class="d-flex align-items-center justify-content-between"
                           :class="{ 'text-dark' : currentQuestion.id === question.id }"
                           @click="changeCurrentQuestion(question)">
                            <span>
                                Question {{ question.id }}: {{ question.question }}
                            </span>
                            <div class="d-flex gap gap-2">
                                <span>
                                    <question-favorite :question="question"
                                                       @update:item="updateFavorite"></question-favorite>
                                </span>
                                <span>
                                    <i v-if="question.answer?.is_correct" class="ti ti-check text-success"></i>
                                    <i v-else-if="question.answer" class="ti ti-close text-danger"></i>
                                    <i v-else class="ti ti-time text-muted"></i>
                                </span>
                            </div>
                        </a>

                    </div>
                </template>
            </div>
            <div class="text-center mb-2">
                <Bootstrap5Pagination
                    class="mb-0"
                    :data="{
                    meta : meta,
                }"
                    :limit="2"
                    :show-disabled="false"
                    :size="'default'"
                    :align="'center'"
                    @pagination-change-page="setCurrentPage"
                />
            </div>
        </div>


        <div class="card rounded shadow mb-2" v-if="currentQuestion && currentQuestion.links?.length > 0">
            <div class="p-3 border-bottom">
                <h5 class="title mb-0">
                    <i class="ti ti-link text-muted"></i>
                    Links
                </h5>
            </div>

            <div class="p-3">
                <a href="javascript:void(0)"
                   class="features feature-primary d-flex align-items-center justify-content-between mb-3"
                   v-for="link in currentQuestion.links" :key="link.id">
                    <div class="d-flex align-items-center">
                        <div class="flex-1">
                            <h6 class="mb-0 text-muted">{{ link.name ?? link.title }}</h6>
                            <small class="text-muted">
                                <a :href="link.url" target="_blank">{{ link.title ?? link.url }}</a>
                            </small>
                        </div>
                    </div>
                    <RatingButtons
                        :id="link.id"
                        type="link"
                        :difference="link?.likes?.difference"
                        :user_like="link?.user_like"
                        @update:user_like="link.user_like = $event"
                    />
                </a>
            </div>
        </div>

        <div class="card rounded shadow mb-2" v-if="currentQuestion && currentQuestion.videos?.length > 0">
            <div class="p-3 border-bottom">
                <h5 class="title mb-0">
                    <i class="ti ti-video-clapper text-muted"></i> Media
                </h5>
            </div>

            <div class="p-3">
                <div class="mb-3" v-for="video in currentQuestion.videos" :key="video.id">
                    <a :href="video.video_url" v-if="video?.thumbnail != null" target="_blank">
                        <img :src="video.thumbnail" class="img-fluid rounded mb-2" alt="...">
                    </a>

                    <div class="d-flex align-items-center justify-content-between">
                        <a :href="video.video_url" class="features feature-primary" target="_blank">
                            <div class="d-flex align-items-center">
                                <div class="d-flex flex-column">
                                    <small class="text-muted mb-1">{{ video.name }}</small>
                                </div>
                            </div>
                        </a>
                        <RatingButtons
                            :id="video.id"
                            type="video"
                            :difference="video?.likes?.difference"
                            :user_like="video?.user_like"
                            @update:user_like="video.user_like = $event"
                        />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import RatingButtons from "../share/RatingButtons.vue";
import axios from "axios";

import {useToast} from "vue-toastification";
import questionFavorite from "../question_favorite/create.vue";

const toast = useToast();
import {Bootstrap5Pagination} from "laravel-vue-pagination";
import NoteCard from "./NoteCard.vue";

export default {
    props: {
        currentQuestion: Object,
        allQuestions: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: 'session'
        },
        meta: {
            type: Object,
            required: true
        },
        isEnd: {},
        result: {
            type: Object,
            required: false,
            default: () => {
                return {
                    result : 0,
                    total_questions : 0,
                    total_correct_questions : 0
                }
            }
        },
    },
    components: {NoteCard, questionFavorite, RatingButtons, Bootstrap5Pagination},
    // watch: {
    //     // مراقبة التغيرات في currentQuestion
    //     currentQuestion: {
    //         handler(newQuestion, oldQuestion) {
    //             // تحديث currentNote بناءً على القيمة الجديدة للنوت
    //             if (newQuestion && newQuestion.note && newQuestion.note?.text) {
    //                 this.currentNote = newQuestion.note?.text;
    //             } else {
    //                 this.currentNote = '';  // إعادة تعيين إذا لم يكن هناك نوت
    //             }
    //         },
    //         deep: true  // لضمان تعقب التغيرات العميقة داخل الكائن
    //     }
    // },
    created() {
        // // تحديث currentNote بناءً على القيمة الأولية للنوت
        // if (this.currentQuestion && this.currentQuestion.note && this.currentQuestion.note?.text) {
        //     this.currentNote = this.currentQuestion.note?.text;
        // }
    },
    data() {
        return {
            // height: 150,  // Default height, adjust as needed
            // currentNote: '',
            editorOptions: {
                modules: {
                    toolbar: [
                        [{header: [1, 2, false]}],
                        ['bold', 'italic', 'underline'],
                        ['image', 'code-block']
                    ]
                },
                placeholder: 'Write your note here...',
                theme: 'snow'  // or 'bubble'
            },
        };
    },
    mounted() {
        // this.adjustHeight();
    },
    methods: {
        setCurrentPage(page) {
            console.log('C', page);
            this.$emit('update:currentPage', page);
        },
        // adjustHeight(event) {
        //     // const textarea = this.$refs.autoHeightTextarea;
        //     // textarea.style.height = 'auto';  // Reset height to recalculate
        //     // this.height = textarea.scrollHeight;  // Set the height to scroll height
        // },
        // saveNote() {
        //
        //     const id = toast.info('save note ...', {icon: 'fa-solid fa-download'});
        //
        //     const noteData = {
        //         question_id: this.currentQuestion.id,
        //         text: this.currentNote,
        //         'subscribe_id': this.$route.params?.subscribe_id
        //     };
        //
        //     this.currentQuestion.note = {'text': this.currentNote};
        //     axios.post(
        //         'notes', noteData
        //     ).then(response => {
        //         toast.dismiss(id);
        //         toast.success(response.data.message, {timeout: 1000, icon: 'fa-solid fa-circle-check'});
        //         this.$emit('update:currentQuestion', {
        //             ...this.currentQuestion,
        //             answer: response.data.data,
        //             options: response.data.options
        //         });
        //     }).catch(error => {
        //         toast.dismiss(id);
        //         if (error.response) {
        //             toast.error(error.response.data.message, {timeout: 3000, icon: 'fa-solid fa-circle-exclamation'});
        //         }
        //     });
        // },
        updateFavorite(newFavorite) {
            this.currentQuestion.favorite = newFavorite.favorite ?? null;
        },
        changeCurrentQuestion(question) {
            this.$emit('update:changeQuestion', question);
        }
    },
};
</script>


<style scoped>
/* Add any styles specific to the links and media here */
textarea {
    resize: none;
}
</style>


<!--<style scoped>-->
<!--/* Add any styles specific to the links and media here */-->
<!--textarea {-->
<!--    resize: none;-->
<!--    min-height: 50px;-->
<!--    width: 100%;-->
<!--    box-sizing: border-box;-->
<!--    overflow: hidden;-->
<!--}-->
<!--</style>-->
